import $ from 'jquery'
import { addCallback } from './activities'

export function initialise() {
  addCallback(() =>
    setTimeout(() => {
      $('[data-item-limit]').each((i, elem) => {
        const $container = $(elem)
        const limit = $container.data('item-limit')
        const selector = $container.data('item-limit-selector') || '*'
        const $items = $container.find(` > ${selector}:visible`)
        if ($items.length > limit)
          $items.each((i, elem) => {
            if (i > limit - 1) $(elem).hide()
          })
      })
    })
  )
}
